/* The Przegląd tab's „Rozliczenie" band — T-K1: a heading, then one card of three columns ruled
 * off from each other (Saldo, Żetony, Nadchodzące), 18px 22px inside each, over the tab's own
 * card surface. The card holds its loaded height (`--h-credit-band`) while it waits, so the answer
 * changes ink and never the cards below it. */

.band {
  display: flex;
  flex-direction: column;
  gap: var(--space-10px);
}

/* The acts take the room their two pills need and never wrap — a wrapped pair would make the
 * band a row taller than the room its wait held; the standing and the next session share the
 * rest. */
.card {
  display: grid;
  grid-template-columns: minmax(0, 1fr) max-content minmax(0, 1fr);
  min-height: var(--h-credit-band);
  background: var(--bg-card);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-card);
}

.column {
  display: grid;
  gap: var(--space-10px);
  align-content: start;
  justify-items: start;
  min-width: 0;
  padding: var(--space-18px) var(--space-22px);
}

.column + .column {
  border-left: var(--border-hairline) solid var(--border);
}

.figure {
  display: flex;
  gap: var(--space-3);
  align-items: flex-end;
  min-width: 0;
}

.figureValue {
  font-size: var(--fs-credit-figure);
  font-weight: var(--fw-extrabold);
  font-variant-numeric: tabular-nums;
  line-height: var(--lh-none);
  color: var(--text);
  letter-spacing: var(--ls-display);
}

.figureWords {
  display: grid;
  min-width: 0;
}

.figureUnit {
  font-size: var(--fs-body);
  font-weight: var(--fw-extrabold);
  color: var(--text);
}

.note {
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  line-height: var(--lh-note);
  color: var(--text-2);
}

.acts {
  display: flex;
  gap: var(--space-2);
}

.when {
  font-size: var(--fs-session);
  font-weight: var(--fw-extrabold);
  font-variant-numeric: tabular-nums;
  color: var(--text);
}

.what {
  font-size: var(--fs-label);
  font-weight: var(--fw-medium);
  color: var(--text-2);
}

.link {
  font-size: var(--fs-foot);
  text-decoration: none;
}

.failed {
  display: flex;
  grid-column: 1 / -1;
  gap: var(--space-3);
  align-items: center;
  padding: var(--space-18px) var(--space-22px);
  font-size: var(--fs-note);
  font-weight: var(--fw-medium);
  color: var(--text-2);
}

.barEyebrow {
  width: 30%;
  height: var(--space-2);
}

.barLine {
  width: 70%;
  height: var(--space-6);
}

.barShort {
  width: 45%;
  height: var(--space-3);
}
